import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';

import { Observable, Subscription } from 'rxjs';
import { tap } from 'rxjs/operators';
import { ScrollService } from 'src/app/services/scroll.service';
import { ROUTE_NAMES } from 'src/app/constants/route_names';

@Component({
  selector: 'app-dementia-types',
  templateUrl: './dementia-types.component.html',
  styleUrls: ['./dementia-types.component.css'],
})
export class DementiaTypesComponent implements OnInit, OnDestroy {
  lightText = '';
  darkText = '';
  cards: any[] = [
    {
      id: 'dementia-types-4049',
      title: 'Поширені типи деменції',
      link: `/${ROUTE_NAMES.aboutDementia}/${ROUTE_NAMES.dementiaTypes}`,
      dementiaMenuId: 2024,
    },
    {
      id: 'dementia-types-4050',
      title: 'Що таке рання деменція?',
      link: `/${ROUTE_NAMES.aboutDementia}/${ROUTE_NAMES.dementiaTypes}`,
      dementiaMenuId: 2024,
    },
    {
      id: 'dementia-types-4051',
      title: "Пов'язані стани",
      link: `/${ROUTE_NAMES.aboutDementia}/${ROUTE_NAMES.dementiaTypes}`,
      dementiaMenuId: 2024,
    },
  ];
  sectionCards: any[] = [];
  currentBreadcrumb: string | null = 'second';
  isLoaded = false;
  private routeSubscription: Subscription | null = null;

  constructor(
    private http: HttpClient,
    private route: ActivatedRoute,
    private router: Router,
    private scrollService: ScrollService,
  ) {}

  ngOnInit(): void {
    this.routeSubscription = this.route.params.subscribe(params => {
      const routeId = params['secondId'];
      this.router.navigate([], { state: { id: routeId } });
      this.fetchCardList()
        .pipe(
          tap((data: any[]) => {
            this.lightText = data[0].contentLight;
            this.darkText = data[0].contentDark;

            this.sectionCards = data[0].menuSubTitle.map((el: any) => ({
              subMenuCards: [
                ...el.SubMenuCards.map((card: any) => ({
                  link:
                    `/${ROUTE_NAMES.aboutDementia}/${ROUTE_NAMES.dementiaTypes}/` +
                    card.cardId,
                  cardTitle: card.cardTitle,
                })),
              ],
            }));

            this.currentBreadcrumb = data[0].menuTitle;
            const element = document.querySelector(
              '[data-breadcrumb="second"]',
            );
            if (element) {
              element.innerHTML = data[0].menuTitle;
            }
            this.scrollService.setLoaded(true);
          }),
        )
        .subscribe();
    });
  }

  fetchCardList(): Observable<any[]> {
    const url = `https://nezabutni-backend.vercel.app/api/second-page?id=dementia-types`;
    return this.http.get<any[]>(url);
  }
  ngOnDestroy(): void {
    if (this.routeSubscription) {
      this.routeSubscription.unsubscribe();
    }
  }
}
